import axios from "axios";
import store from "../store/index.js";
import { Environment } from "./Environment";

const RETRYABLE_STATUSES = [502, 503, 504];
const MAX_RETRIES = 3;

const DEFAULT_TIMEOUT = 20000; // 20 seconds

const baseConfig = {
  baseURL: Environment.get("VUE_APP_API2_HOST") + "/api/",
  timeout: DEFAULT_TIMEOUT,
  headers: {
    authorization: "Bearer " + localStorage.token,
  },
  params: {},
  //withCredentials: true
};

const instance = axios.create(baseConfig);

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getBackoffDelay(retryCount, base = 200) {
  const jitter = Math.floor(Math.random() * 100);
  return Math.min(10000, base * 2 ** retryCount + jitter);
}

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    if (!config || config._retryCount >= MAX_RETRIES) {
      return Promise.reject(error);
    }

    const status = error.response?.status;

    // 4. IMPROVED retry logic (won't retry on timeouts)
    const isTimeout = error.code === "ECONNABORTED";
    const isNetworkError = !status && !isTimeout;
    const isGatewayError = RETRYABLE_STATUSES.includes(status);
    const shouldRetry = isNetworkError || isGatewayError;

    if (!shouldRetry) {
      if (error.response && error.response.status === 401) {
        store.dispatch("setToken", null);
        store.dispatch("setUser", null);
        localStorage.removeItem("token");
        console.log("Token expired, user logged out");
      }
      return Promise.reject(error);
    }

    config._retryCount = (config._retryCount || 0) + 1;

    // 5. IMPROVED cookie clearing (only on first retry)
    if (config._retryCount === 1) {
      document.cookie = "AWSALB=; Max-Age=0; path=/";
      document.cookie = "AWSALBTG=; Max-Age=0; path=/";
    }

    const backoff = getBackoffDelay(config._retryCount);
    console.log(
      `Api Retry #${config._retryCount} after ${backoff}ms for status ${
        status || "network error"
      }`
    );

    await delay(backoff);
    return instance(config);
  }
);

export default (timeout = null) => {
  if (timeout === null || timeout === DEFAULT_TIMEOUT) {
    return instance;
  }
  return axios.create({
    ...baseConfig,
    timeout: timeout,
  });
};
